// extracted by mini-css-extract-plugin
module.exports = {"row":"TAC_row__okCSq","title":"TAC_title__LB61Z","content":"TAC_content__9BL91"};